import { getHeaderMenuConfig } from './header-menu-config.util';

/**
 * Checks whether online registration for Troupe Owners is closed.
 * Returns true if cutoff date passed OR if Support role disabled the register menu in site config.
 */
export function isRegistrationClosed(): boolean {
  const menuConfig = getHeaderMenuConfig();
  if (menuConfig.troupeRegister === false) {
    return true;
  }
  // The cutoff has been removed so registration remains open
  return false;
}

/**
 * Checks whether online registration for Requesting Agencies (RA) is closed.
 * RA registration is currently open independently of the troupe registration cutoff.
 */
export function isAgencyRegistrationClosed(): boolean {
  const menuConfig = getHeaderMenuConfig();
  if (menuConfig.raRegister === false) {
    return true;
  }
  // RA registration is open — no cutoff applied
  return false;
}
